<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!verificarPermissao('PERM_EDITAR_CENTRAL_CLIENTE')">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="verificarPermissao('PERM_EDITAR_CENTRAL_CLIENTE')">
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-full">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid" *ngIf="cliente && !exibirSpinnerPrincipal">
						<div class="field col-12 md:col-5">
							<label htmlFor="nome">Cliente</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite o nome e sobrenome" name="nome" ngModel [(ngModel)]="cliente.nome"
								#nome="ngModel" required />
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="apelido">Nome</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite o apelido" name="apelido" ngModel [(ngModel)]="cliente.apelido"
								#nome="ngModel" />
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="cpf">CPF</label>
							<p-inputMask mask="999.999.999-99" [unmask]="true" type="text" placeholder="000.000.000-00"
								name="cpf" ngModel #cpf="ngModel" [(ngModel)]="cliente.cpf"> </p-inputMask>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="aniversario">Aniversário</label>
							<p-inputMask mask="99/99" type="text" placeholder="DD/MM" name="aniversario" ngModel
								#aniversario="ngModel" [(ngModel)]="aniversarioCliente" (onBlur)="validarAniversario()">
							</p-inputMask>
							<div *ngIf="!dataValida" class="alerta">
								<small>Data inválida</small>
							</div>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="email">E-mail</label>
							<input pInputText type="email" placeholder="seuemail@mail.com" name="email" ngModel
								email="true" #email="ngModel" [(ngModel)]="cliente.email" />
							<div *ngIf="email.hasError('email')" class="alerta">
								<small>Digite um e-mail válido</small>
							</div>
						</div>


						<div class="field col-12 md:col-3">
							<label htmlFor="indicador">Indicador Cliente</label>
							<p-dropdown [options]="indicadoresClientes" [filter]="true"
								emptyFilterMessage="Nenhum registro" [(ngModel)]="cliente.indicadorCliente"
								placeholder="Não informado" name="indicador"></p-dropdown>
						</div>
						<div class="field col-12 md:col-2">
							<label for="status">Ativo</label>
							<br />
							<p-inputSwitch name="status" [(ngModel)]="cliente.status"
							></p-inputSwitch>
						</div>

						

					</div>
					<div class="p-fluid p-formgrid grid my-5 px-3" *ngIf="cliente && !exibirSpinnerPrincipal">
						<div class="col-12 card-simple">
							<div class="grid">
								<div class="col-12 md:col-12">
									<h5>Contatos</h5>
								</div>
								<div class="field col-12 md:col-3">
									<label htmlFor="numeroContato">Número</label>
									<p-inputMask mask="(99)99999-9999" placeholder="(99)99999-9999" name="numeroContato"
										[(ngModel)]="contatoCliente.numero"></p-inputMask>
								</div>
								<div class="field col-12 md:col-3">
									<label htmlFor="identificacao">Identificação</label>
									<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
										name="identificacao" placeholder="Descrição"
										[(ngModel)]="contatoCliente.identificacao" />
								</div>

								<div class="field col-12 md:col-1">
									<label for="principal">Principal?</label>
									<br />
									<p-inputSwitch name="principal"
										[(ngModel)]="contatoCliente.principal"></p-inputSwitch>

								</div>
								<div class="field col-12 md:col-2">
									<button type="button" pButton class="p-button-success mt-5"
										(click)="adicionarContato()"
										[disabled]="loadingAdicionarContato || loadingExcluirContato"
										[icon]="loadingAdicionarContato ? 'pi pi-spin pi-spinner':'pi pi-check'"></button>
								</div>

							</div>

							<p-table #dt1 [value]="listaContatos" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm"
								[loading]="loadingAdicionarContato || loadingExcluirContato">

								<ng-template pTemplate="header">
									<tr>
										<th>
											<div class="flex justify-content-between align-items-center">
												Número
											</div>
										</th>
										<th>
											<div class="flex justify-content-between align-items-center">
												Identificador
											</div>
										</th>
										<th>
											<div class="flex justify-content-between align-items-center">
												Principal
											</div>
										</th>
										<th>
											<div class="flex justify-content-between align-items-center">
												Ações
											</div>
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											{{item.numero}}
										</td>
										<td>
											<label>{{item.identificacao ? item.identificacao : 'Não informado'}}</label>
										</td>
										<td>
											<label>{{item.principal ? 'Sim' : 'Não'}}</label>
										</td>
										<td>
											<button [disabled]="mostrarBotoes()" pButton pRipple pTooltip="Editar"
												type="button" icon="pi pi-pencil" class="p-button-success mr-2 mb-2"
												(click)="editarContato(item)"></button>
											<button pButton pRipple pTooltip="Excluir" type="button"
												class="p-button-danger mr-2 mb-2 sm"
												[icon]="loadingExcluirContato? 'pi pi-spin pi-spinner':'pi pi-trash'"
												(click)="excluirContato(item.id)"></button>
										</td>

									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum contato adicionado.</td>
									</tr>
								</ng-template>

							</p-table>

						</div>

					</div>
					<div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!exibirSpinnerPrincipal">
						<div class="col-12 md:col-4">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso" type="submit" pButton
								icon="pi pi-check" label="Atualizar"
								class="p-button-outlined p-button-success md:w-9rem" (click)="atualizar()"
								[disabled]="!dataValida">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Atualizar"
									class="p-button-outlined p-button-success md:w-9rem">
								</button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/central-cliente"></button>
						</div>
					</div>
				</div>
			</form>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>
		</div>
	</div>
</div>